import { AccountCertification } from '@wix/ambassador-academy-certifications-v1-account-certification/types';
import React from 'react';
import CertificationsCarousel from './CertificationsCarousel';
import CertificationsGrid from './CertificationsGrid';

interface DetailedCertificationsProps {
  certifications: AccountCertification[];
  shouldUseCarousel: boolean;
  maxSlideIndex: number;
  isMobileView?: boolean;
  onGradientStateChange?: (showLeft: boolean, showRight: boolean) => void;
}

const DetailedCertifications: React.FC<DetailedCertificationsProps> = ({
  certifications,
  shouldUseCarousel,
  maxSlideIndex,
  isMobileView,
  onGradientStateChange,
}) => {
  if (shouldUseCarousel) {
    return (
      <CertificationsCarousel
        certifications={certifications}
        isMobileView={isMobileView}
        maxSlideIndex={maxSlideIndex}
        onGradientStateChange={onGradientStateChange}
      />
    );
  }

  return (
    <CertificationsGrid
      certifications={certifications}
      isMobileView={isMobileView}
    />
  );
};

export default DetailedCertifications;
